import { queryOperationRecord } from '@api/announcement';
import TimeLineCancel from '@assets/image/timeline-cancel.svg';
import TimeLineCopy from '@assets/image/timeline-copy.svg';
import TimeLineForward from '@assets/image/timeline-forward.svg';
import TimeLineOk from '@assets/image/timeline-ok.svg';
import TimeLineCreate from '@assets/image/timeline_created.svg';
import TimeLineDel from '@assets/image/timeline_delete.svg';
import { TIMELINE_STATUS } from '@views/pages/AnnouncementList/announcement';
import { RecordSceneEnum } from '@views/pages/ProjectDetails/type';
import { Timeline } from 'antd';
import { useMemo, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useForwardAnnouncement } from '../../views/pages/AnnouncementDetails/hooks/AnnouncementDetail/ForwardAnnouncement/useForwardAnnouncement';
import './index.scss';

export const useTimeLine = ({
  details = {},
  getAnnInfo,
  recordScene = 1,
  hideForward
}: any) => {
  const [historyList, setHistoryList] = useState([]);
  const [historyCounts, setHistoryCounts] = useState<number>(0);
  const [searchParams] = useSearchParams();
  const { forwardAnnouncementComponent } = useForwardAnnouncement({
    details,
    getAnnInfo
  });

  const getHistoryList = async () => {
    const res = await queryOperationRecord({
      recordScene,
      pageNumber: 1,
      pageSize: 1000,
      noticeCode:
        searchParams.get('noticeId') ||
        searchParams.get('noticeProjectCode') ||
        ''
    });

    setHistoryList(res?.page?.records || []);
    setHistoryCounts(res?.page?.total || 0);
  };

  const renderTimeLineItemTitle = (item: any) => {
    const {
      recordAction,
      createUserName,
      receiveUserName,
      recordActionFiled,
      recordActionValue
      // recordScene
    } = item;
    if (
      recordAction === TIMELINE_STATUS.Sector ||
      recordAction === TIMELINE_STATUS.Sales
    ) {
      return (
        <div className="title-row">
          {createUserName} <span className="title-text">转交给</span>{' '}
          {receiveUserName}
        </div>
      );
    } else if (recordAction === TIMELINE_STATUS.Uncorrelated) {
      return (
        <div className="title-row">
          {createUserName} <span className="title-text">标记不相关</span>
        </div>
      );
    } else if (recordAction === TIMELINE_STATUS.SubjectMatterUncorrelated) {
      return (
        <div className="title-row">
          {receiveUserName} <span className="title-text">标记</span>{' '}
          <span className="title-text-blue">{recordActionFiled}</span>{' '}
          <span className="title-text">为不相关</span>
        </div>
      );
    } else if (recordAction === TIMELINE_STATUS.Repetition) {
      return (
        <div className="title-row">
          {createUserName} <span className="title-text">标记重复</span>
        </div>
      );
    } else if (recordAction === TIMELINE_STATUS.SubjectMatterRepetition) {
      return (
        <div className="title-row">
          {receiveUserName} <span className="title-text">标记</span>{' '}
          <span className="title-text-blue">{recordActionFiled}</span>{' '}
          <span className="title-text">为关联项目</span>
        </div>
      );
    } else if (recordAction === TIMELINE_STATUS.Created) {
      return (
        <div className="title-row">
          {createUserName} <span className="title-text">为</span>
          <span className="title-text-blue">{recordActionFiled}</span>
          <span className="title-text-green">新建项目</span>
        </div>
      );
    } else if (
      recordAction === TIMELINE_STATUS.Delete &&
      recordScene === RecordSceneEnum['sales']
    ) {
      return (
        <div className="title-row">
          {createUserName}{' '}
          <span className="title-text">{recordActionValue}</span>
        </div>
      );
    } else if (recordAction === TIMELINE_STATUS.Delete) {
      return (
        <div className="title-row">
          {createUserName} <span className="title-text">为</span>
          <span className="title-text-blue">{recordActionFiled}</span>
          <span className="title-text-red">删除项目</span>
        </div>
      );
    } else if (
      recordAction === TIMELINE_STATUS.revertAnnouncement ||
      recordAction === TIMELINE_STATUS.revertSubjectMatter ||
      recordAction === TIMELINE_STATUS.revertProject
    ) {
      return (
        <div className="title-row">
          {createUserName}{' '}
          <span className="title-text">{recordActionValue}</span>
          <span className="title-text-blue">{recordActionFiled}</span>
        </div>
      );
    } else if (recordAction === TIMELINE_STATUS.transferToDealer) {
      return (
        <div className="title-row">
          {createUserName} <span className="title-text">分配给</span>{' '}
          {receiveUserName}
        </div>
      );
    } else {
      return (
        <div className="title-row">
          {createUserName}{' '}
          <span className="title-text">{recordActionValue}</span>
        </div>
      );
    }
  };

  const renderTimeLineItem = (item: any) => {
    const { createTime, recordRemark } = item;
    return (
      <div>
        <div className="timeLine-item-title">
          {renderTimeLineItemTitle(item)}
        </div>
        <div className="timeLine-item-remark">{recordRemark}</div>
        <div className="timeLine-item-date">{createTime}</div>
      </div>
    );
  };

  // 2:转Sector,3:转销售,5:标记不相关,6:标记重复,7:创建项目,8:更新字段,9:删除项目，10:关联项目,55:标的物标记不相关,66:标的物标记重复
  const renderTimeLineItemDot = (recordAction: number) => {
    TIMELINE_STATUS;
    const obj: any = {
      [TIMELINE_STATUS.Sector]: <img src={TimeLineForward} alt="" />,
      [TIMELINE_STATUS.Sales]: <img src={TimeLineForward} alt="" />,
      [TIMELINE_STATUS.Uncorrelated]: <img src={TimeLineCancel} alt="" />,
      [TIMELINE_STATUS.SubjectMatterUncorrelated]: (
        <img src={TimeLineCancel} alt="" />
      ),
      [TIMELINE_STATUS.Repetition]: <img src={TimeLineCopy} alt="" />,
      [TIMELINE_STATUS.SubjectMatterRepetition]: (
        <img src={TimeLineCopy} alt="" />
      ),
      [TIMELINE_STATUS.Confirmed]: <img src={TimeLineOk} alt="" />,
      [TIMELINE_STATUS.Delete]: <img src={TimeLineDel} alt="" />,
      [TIMELINE_STATUS.Created]: <img src={TimeLineCreate} alt="" />
    };
    return obj[recordAction] || '';
  };

  const items = useMemo(() => {
    return historyList.map((item) => {
      const { recordAction } = item;
      return {
        children: renderTimeLineItem(item),
        dot: renderTimeLineItemDot(recordAction)
      };
    });
  }, [historyList]);

  const timeLineComponent = (
    <div className="pc_timeline_wrap">
      <div className="history_title">操作历史</div>
      <div className="history_counts">
        共 <span>{historyCounts}</span> 条
      </div>
      <div className="history_mian">
        <Timeline
          items={items}
          mode="left"
          className="announcement_detail_timeline"
        />
      </div>
      {!hideForward && forwardAnnouncementComponent}
    </div>
  );
  return {
    timeLineComponent,
    getHistoryList
  };
};
